import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
  audioGuideContainer: {
    marginLeft: '10px',
    marginRight: '10px',
    marginTop: '10px',
    marginLBottom: '10px',
  },
  audioGuideTitle: {
    fontWeight: 'bold',
    paddingBottom: '5px',
  },
  audioMusicTitle: {
    paddingTop: '5px',
    paddingBottom: '5px',
  },
  audioMusicTitleContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  audioMusicSelect: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  audioMusicContainer: {
    marginTop: '10px',
    marginBottom: '10px',
  },
});
